import React from 'react';

const ContentHeader = ({title}: {title: string}) => {
  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h2><b>{title}</b></h2>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContentHeader;
